// extracted by mini-css-extract-plugin
export default {"root":"f4YolRsNsl9OvnbHTjaW"};